import React, { useState } from 'react';
import Icon from '@mdi/react';
import { mdiContentCopy, mdiLinkVariant, mdiChevronDown, mdiChevronUp, mdiPlus } from '@mdi/js';
import { toast } from 'react-toastify';
import './TrialDealUrlPanel.css';

const BASE = `${window.location.origin}/trial`;

const CHANNELS = [
    { label: 'Facebook', params: 'utm_source=facebook&utm_medium=social' },
    { label: 'Instagram', params: 'utm_source=instagram&utm_medium=social' },
    { label: 'Google Ads', params: 'utm_source=google&utm_medium=cpc' },
    { label: 'Email', params: 'utm_source=email&utm_medium=email' },
];

function copyUrl(url) {
    navigator.clipboard.writeText(url)
        .then(() => toast.success('URL copied!'))
        .catch(() => toast.error('Could not copy — please copy the URL manually'));
}

const TrialDealUrlPanel = ({ trialDeal }) => {
    const [builderOpen, setBuilderOpen] = useState(false);
    const [utmSource, setUtmSource] = useState('');
    const [utmMedium, setUtmMedium] = useState('');
    const [utmCampaign, setUtmCampaign] = useState('');

    const slug = trialDeal?.slug || '';
    const baseUrl = `${BASE}/${slug}`;

    const buildCustomUrl = () => {
        const params = new URLSearchParams();
        if (utmSource.trim()) params.set('utm_source', utmSource.trim());
        if (utmMedium.trim()) params.set('utm_medium', utmMedium.trim());
        if (utmCampaign.trim()) params.set('utm_campaign', utmCampaign.trim());
        const qs = params.toString();
        return qs ? `${baseUrl}?${qs}` : baseUrl;
    };

    return (
        <div className="trial-deal-url-panel">
            <div className="trial-deal-url-panel__heading">
                <Icon path={mdiLinkVariant} size={0.85} color="var(--dl-color-purple-default)" />
                <span>Tracked URLs</span>
            </div>

            {/* Base URL */}
            <div className="trial-deal-url-panel__row">
                <span className="trial-deal-url-panel__label">Untracked</span>
                <span className="trial-deal-url-panel__url">{baseUrl}</span>
                <button
                    className="trial-deal-url-panel__copy-btn"
                    onClick={() => copyUrl(baseUrl)}
                    title="Copy URL">
                    <Icon path={mdiContentCopy} size={0.75} />
                </button>
            </div>

            {/* Per-channel rows */}
            {CHANNELS.map(ch => {
                const url = `${baseUrl}?${ch.params}`;
                return (
                    <div key={ch.label} className="trial-deal-url-panel__row">
                        <span className="trial-deal-url-panel__label">{ch.label}</span>
                        <span className="trial-deal-url-panel__url">{url}</span>
                        <button
                            className="trial-deal-url-panel__copy-btn"
                            onClick={() => copyUrl(url)}
                            title={`Copy ${ch.label} URL`}>
                            <Icon path={mdiContentCopy} size={0.75} />
                        </button>
                    </div>
                );
            })}

            {/* Custom URL builder */}
            <button
                className="trial-deal-url-panel__expander-btn"
                onClick={() => setBuilderOpen(v => !v)}>
                <Icon path={mdiPlus} size={0.75} />
                Build custom tracked URL
                <Icon path={builderOpen ? mdiChevronUp : mdiChevronDown} size={0.75} style={{ marginLeft: 'auto' }} />
            </button>

            {builderOpen && (
                <div className="trial-deal-url-panel__builder">
                    <div className="trial-deal-url-panel__builder-fields">
                        <div className="trial-deal-url-panel__builder-field">
                            <label className="trial-deal-url-panel__builder-label">utm_source *</label>
                            <input
                                className="trial-deal-url-panel__builder-input"
                                placeholder="e.g. instagram"
                                value={utmSource}
                                onChange={e => setUtmSource(e.target.value)}
                            />
                        </div>
                        <div className="trial-deal-url-panel__builder-field">
                            <label className="trial-deal-url-panel__builder-label">utm_medium</label>
                            <input
                                className="trial-deal-url-panel__builder-input"
                                placeholder="e.g. social"
                                value={utmMedium}
                                onChange={e => setUtmMedium(e.target.value)}
                            />
                        </div>
                        <div className="trial-deal-url-panel__builder-field">
                            <label className="trial-deal-url-panel__builder-label">utm_campaign</label>
                            <input
                                className="trial-deal-url-panel__builder-input"
                                placeholder="e.g. mothers-day-2026"
                                value={utmCampaign}
                                onChange={e => setUtmCampaign(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="trial-deal-url-panel__builder-preview">
                        <span className="trial-deal-url-panel__url">{buildCustomUrl()}</span>
                        <button
                            className="trial-deal-url-panel__copy-btn"
                            onClick={() => copyUrl(buildCustomUrl())}
                            disabled={!utmSource.trim()}
                            title="Copy custom URL">
                            <Icon path={mdiContentCopy} size={0.75} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TrialDealUrlPanel;
